import { Button, Grid, Stack, Typography } from "@mui/joy";
import { theme } from "../Theme";
import { Link, useParams } from "react-router-dom";
import { ReactNode } from "react";
import { If, IfElse } from "../Condition";
import { EditOutlined } from "@mui/icons-material";
import { SxProps } from "@mui/material";

type Props = {
  data: {
    title: string;
    value: string | ReactNode;
  }[];
  editable?: boolean;
  containerStyle?: SxProps; // allows styling container
  columns?: number;
  columnsXs?: number;
  infoOrientation?: "column" | "row";
};

const CatalogueMetadata = ({
  data,
  editable = false,
  containerStyle,
  columns = 3,
  columnsXs = 1,
  infoOrientation = "row",
}: Props) => {
  const { catalogId } = useParams();

  return (
    <Stack
      direction={"row"}
      spacing={1}
      sx={
        containerStyle ?? {
          background: "var(--Neutral-050, #F9FAFB)",
          p: "16px",
        }
      }
    >
      <Grid
        container
        lg={12}
        columnSpacing={{ md: 1 }}
        rowGap={"4px"}
        width={"100%"}
      >
        {data.map(({ title, value }) => (
          <InfoItem
            key={title}
            title={title}
            value={value}
            columns={columns}
            columnsXs={columnsXs}
            infoOrientation={infoOrientation}
          />
        ))}
      </Grid>

      <If condition={editable}>
        <Link to={`/client/catalogues/${catalogId}/edit`}>
          <Button
            id="catalog-edit-button"
            variant="linkz-outlined-neutral"
            size="sm"
          >
            <EditOutlined width={"24px"} height={"24px"} />
          </Button>
        </Link>
      </If>
    </Stack>
  );
};

const InfoItem = ({
  title,
  value,
  columns,
  columnsXs,
  infoOrientation,
}: {
  title: string;
  value: string | ReactNode;
  columns: number;
  columnsXs: number;
  infoOrientation: "column" | "row";
}) => {
  return (
    <Grid xs={12 / columnsXs} lg={12 / columns}>
      <Stack direction={infoOrientation}>
        <Typography
          level="text-xs-medium"
          textColor={theme.palette.others.secondary_text}
          width={{ xs: "40%", md: "45%" }}
        >
          {title}
        </Typography>

        <IfElse
          condition={typeof value === "string"}
          ifBlock={
            <Typography
              level="text-xs-semibold"
              textColor={theme.palette.common.black}
            >
              {infoOrientation === "row" && ":"} {value}
            </Typography>
          }
          elseBlock={value}
        />
      </Stack>
    </Grid>
  );
};

export default CatalogueMetadata;
